module.exports = __webpack_public_path__ + "img/kit-banner.03e784e8.png";